import { createAction } from '@reduxjs/toolkit';

export const storeCleanup = createAction('storeCleanup', (eventIds = []) => {
    const payload = {
        eventIds: [...eventIds].map(String),
    };

    return { payload };
});
